// extracted by mini-css-extract-plugin
module.exports = {"NoLocation":"NoLocation_NoLocation__vTZ7f","LocIcon":"NoLocation_LocIcon__zdOKS","NoLocText":"NoLocation_NoLocText__BOexw"};